import { BriefcaseIcon } from '@heroicons/react/20/solid'

const TONE_CLASS = {
	emerald: 'bg-emerald-100 text-emerald-800',
	indigo: 'bg-indigo-100 text-indigo-800',
}

function TrainingItemMonth({ title, isRangeStart = false, isRangeEnd = false, isSingleDay = false, tone = 'emerald' }) {
	const isVisibleRangeStart = isRangeStart && !isRangeEnd
	const isVisibleRangeEnd = isRangeEnd && !isRangeStart
	const isFullyVisibleRange = isSingleDay || (isRangeStart && isRangeEnd)
	const roundedClass = isFullyVisibleRange
		? 'rounded'
		: isVisibleRangeStart
		? 'rounded-l rounded-r-none'
		: isVisibleRangeEnd
		? 'rounded-r rounded-l-none'
		: 'rounded-none'
	const toneClass = TONE_CLASS[tone] || TONE_CLASS.emerald
	return (
		<div
			title={title}
			className={`relative z-10 flex h-6 w-full min-w-0 items-center overflow-hidden whitespace-nowrap px-2 text-left text-xs font-semibold ${toneClass} ${roundedClass}`}>
			{tone === 'indigo' ? (
				<BriefcaseIcon className="mr-1 size-3.5 shrink-0" aria-hidden="true" />
			) : null}
			<span className="block min-w-0 truncate">{title}</span>
		</div>
	)
}

export default TrainingItemMonth
